import React, { useContext } from "react";
import styles from "../../styles/News/NewsItem.module.css";
import moment from "moment";
import { VscCalendar } from "react-icons/vsc";
import NewsContext from "../../context/News/NewsContext";

import SentimentBadge from "./SentimentBadge";
const NewsItem = ({
  imgUrl,
  desc,
  src,
  pdate,
  title,
  url,
  sentiment,
  show,
}) => {
  const { newsLoading, filterType } = useContext(NewsContext);
  return (
    <div
      className={
        filterType !== "Events" || show ? styles.NewsItem : styles.EventsItem
      }
      style={{minHeight:"180px"}}
    >
      {(filterType !== "Events" || show) && (
        <section>
          {newsLoading ? (
            <div
              className="skeleton text"
              style={{
                width: "225px",
                height: "140px",
                borderRadius: "10px",
                margin: 0,
              }}
            />
          ) : (
            <img src={imgUrl} alt="cryptoImage" />
          )}
        </section>
      )}
      <section className={styles.NewsItem__content}>
        {newsLoading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              justifyContent: "center",
            }}
          >
            {filterType === "Events" ? (
              <>
                <div
                  className="skeleton text"
                  style={{ width: "100%", height: "15px" }}
                />
              </>
            ) : (
              <>
                <div
                  className="skeleton text"
                  style={{ width: "100%", height: "15px" }}
                />
                <div
                  className="skeleton text"
                  style={{ width: "100%", height: "15px" }}
                />
                <div
                  className="skeleton text"
                  style={{ width: "100%", height: "15px" }}
                />
              </>
            )}
          </div>
        ) : !show ? (
          <div>
            <h1
              style={{ textDecoration: "none", color: "#000", cursor: "auto" }}
            >
              {title}
            </h1>
          </div>
        ) : (
          <div>
            <a href={url} rel="noopener noreferrer" target="_blank" title={title}>
              <h1>
                {title?.length > 75 ? `${title.substr(0, 75)}...` : title}
              </h1>
            </a>
            <p className={styles.desc}>
              {desc?.length > 300 ? `${desc.substr(0, 300)}...` : desc}
            </p>
          </div>
        )}

        {/* <div className={show?styles.NewsItem__details__show:styles.NewsItem__details}> */}
        <div className={styles.NewsItem__details}>
          {newsLoading && (filterType !== "Events" || show) ? (
            <div
              className="skeleton text"
              style={{
                width: "60px",
                height: "15px",
                borderRadius: "5px",
                margin: 0,
              }}
            />
          ) : filterType !== "Events" ? (
            <p>
              Source: <span>{src}</span>
            </p>
          ) : (
            <></>
          )}

          {newsLoading ? (
            <div
              className="skeleton text"
              style={{
                width: "60px",
                height: "15px",
                borderRadius: "5px",
                margin: 0,
              }}
            />
          ) : (
            <div>
              <VscCalendar size={21} />
              <p>{moment(pdate).format("L")}</p>
            </div>
          )}
          {newsLoading && filterType !== "Events" ? (
            <div
              className="skeleton text"
              style={{
                width: "60px",
                height: "15px",
                borderRadius: "5px",
                margin: 0,
              }}
            />
          ) : filterType !== "Events" ? (
            <SentimentBadge sentiment={sentiment} />
          ) : (
            <></>
          )}
        </div>
      </section>
      {newsLoading && (
        <div className="shimmer-wrapper">
          <div className="shimmer"></div>
        </div>
      )}
    </div>
  );
};

export default NewsItem;
